import { render } from "./ViewEmployeeDetails.vue?vue&type=template&id=a6be78e4&scoped=true"
import script from "./ViewEmployeeDetails.vue?vue&type=script&lang=js"
export * from "./ViewEmployeeDetails.vue?vue&type=script&lang=js"

import "./ViewEmployeeDetails.vue?vue&type=style&index=0&id=a6be78e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6be78e4"]])

export default __exports__